import { useState } from "react";
import Button2 from "../../../Button/Button2";
import { RuleProvider, useRule } from "./RuleReducer";
import ProgressBar from "./ProgressBar";
import { Button } from "primereact/button";

const ChooseAdditionalConditionPin = ({ pins, smartLocks, navigate }) => {
    const { state, dispatch } = useRule(RuleProvider);
    const [progress] = useState(40);

    const HandlePinSelected = (pin) => {
        // Update display state so ChooseWhen renders correctly for this pin
        dispatch({ type: "SET_SELECTED_PIN", payload: pin });
        dispatch({ type: "SET_PIN_NUMBER", payload: pin.Pin });
        dispatch({ type: "SET_IS_LOCK", payload: smartLocks.some(lock => parseInt(lock.outputPin) === pin.Pin) });
        dispatch({ type: "SET_PIN_STATUS_ON", payload: pin.pinStatusOn });
        dispatch({ type: "SET_PIN_STATUS_OFF", payload: pin.pinStatusOff });
        dispatch({ type: "SET_PIN_NAME", payload: pin.pinName });
        dispatch({ type: "SET_IS_PULSE", payload: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" });
        // Reset selection highlight for the new condition
        dispatch({ type: "SET_INPUT_TYPE", payload: -1 });
        dispatch({ type: "SET_INPUT_TYPE_COPY", payload: -1 });

        const newConditionIndex = state.conditions.length;

        const condition = {
            condition_type: "STATE_CHECK",
            pin: pin.Pin,
            pin_name: pin.pinName,
            pin_state: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : pin.pin_state,
            trigger_method: pin.type === "PULSE" || pin.type === "VIRTUAL_PULSE" ? "PULSE" : "LATCH",
            trigger_method_type: "ANY",
            time_condition: "ANYTIME",
            days_of_week: ["0", "1", "2", "3", "4", "5", "6"],
            is_absence_condition: false,
        };

        dispatch({
            type: "SET_ADV_RULE_CONDITION",
            payload: [...state.conditions, condition]
        });

        dispatch({ type: "SET_CONDITION_EDIT_INDEX", payload: newConditionIndex });

        navigate(10);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "16px" }}>
            <ProgressBar progress={progress} />

            {/* Summary of already-configured conditions */}
            {state.conditions.length > 0 && (
                <div style={{ width: "80%", padding: "10px 16px", background: "#f5f5f5", borderRadius: "8px", fontSize: "13px" }}>
                    <p style={{ color: "#6e6e6e", margin: "0 0 6px 0", fontWeight: 600 }}>Already added:</p>
                    {state.conditions.map((cond, i) => (
                        <p key={i} style={{ margin: "3px 0", color: "#9e9e9e" }}>
                            ✓ {i + 1}. {cond.pin_name ?? `Pin ${cond.pin}`}
                        </p>
                    ))}
                </div>
            )}

            <h3 style={{ color: "#6e6e6e", textAlign: "center" }}>Add another condition</h3>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                <ul style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                    {pins.map((pin, index) => (
                        <Button2 style={{ minWidth: "300px", minHeight: "40px" }} key={index} onClick={() => HandlePinSelected(pin)}>
                            {pin.pinName}
                        </Button2>
                    ))}
                </ul>
            </div>
            <Button
                label="Back"
                icon="pi pi-arrow-left"
                severity="secondary"
                onClick={() => navigate(1)}
            />
        </div>
    );
};

export default ChooseAdditionalConditionPin;
